import uhaulStore from "./CustomRedux/UhaulStore";
import GetLiveChatHeader from "./LiveChatHeaderHelper";
function ExceptionLogger(error, methodName, customMessage, clientInfo, otherInfo, isInfoLog = false) {
    try{
        var exceptionDetails = "", stackTrace = "";
        if (error) {
            exceptionDetails = error.message;
            stackTrace = error.stack;
            exceptionDetails = exceptionDetails || error;
            console.error(error);
        } else {
            isInfoLog = true;
        }

        const requestUri = uhaulStore.getState().UhaulReducer.config.liveChatApiUrl;
        const loggingEndpoint = isInfoLog ? "InfoLogs" : "Exceptions";
        if (!requestUri) {
            console.log("Exceptions logging not found.");
            return;
        }
        fetch(requestUri + loggingEndpoint,
            {
                method: "post",
                headers: GetLiveChatHeader(),
                body: JSON.stringify({
                    message: customMessage,
                    innerException: exceptionDetails,
                    stackTrace: stackTrace,
                    helpLink: window.location.href.toString(),
                    source: window.location.href.toString(),
                    methodName: methodName,
                    clientIp: clientInfo,
                    otherInfo: JSON.stringify(otherInfo)
                }) 
            })
            .then(response => response.json())
            .then((json) => {
                if(!json.Success)
                {
                    throw json.Errors ? json.Errors[0] : "Error encounterd logging exception.";
                }
            })
            .catch((err) => console.log("ERROR: ", err));
    }
    catch(e){
        console.error(e);
    }
}

export default ExceptionLogger;
